import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import store from './store';
import { Provider } from 'react-redux';
import { trainingSite, gymSite } from './training/runtime';
import { setupHeadlessBridge } from './headless/bridge';

// Suppress uncaught promise rejections from external Chrome extensions (e.g. content.js "No Listener: tabs:outgoing.message.ready")
if (typeof window !== 'undefined') {
  window.addEventListener('unhandledrejection', function (event) {
    var reason = event?.reason;
    var msg = reason?.message || String(reason || '');
    if (msg.includes('tabs:outgoing.message.ready') || msg.includes('No Listener')) {
      event.preventDefault();
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

if (!trainingSite && !gymSite) setupHeadlessBridge(store);
